<template>
  <v-app :style="'background: ' + config.background">
    <Navbar v-if="navbarVisible" />
    <div
    v-if="error"
    class="error-overlay"
    id="e"
    >
      <v-alert
      border="bottom"
      :color="alertColor"
      dark
      elevation="4"
      >
        <v-row justify="center" align="center">
          <v-icon class="ml-3 mr-5" v-if="alertColor == 'red'">mdi-alert</v-icon>
          <v-icon class="ml-3 mr-5" v-if="alertColor != 'red'">mdi-information</v-icon>
          <div>{{error.message}}</div>
          <v-btn @click="closeError()" class="ml-auto mr-3" icon large>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-alert>
    </div>
    <!-- /\ Top alert \/ Bottom alert (For the cookies message) -->
    <div
    v-if="activateAlert"
    class="main-overlay"
    id="a"
    >
      <v-alert
      :color="config.background_dark"
      dark
      elevation="4"
      >
        <v-row justify="center" align="center">
          <v-icon class="ml-3 mr-5">mdi-alert</v-icon>
          <div v-html="alertText"></div>
          <v-btn @click="activateAlert = false" class="ml-auto mr-3" icon large>
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </v-row>
      </v-alert>
    </div>
    <v-content>
      <v-overlay v-if="activateAlert" id="small-overlay" opacity="0.85">
        <div style="height:120px; width:100%;" />
        <v-container>
          <v-row justify="center" class="my-4 mx-2">
            <div v-html="alertText">
            </div>
          </v-row>
          <v-row justify="center" class="my-4 mx-2">
            <v-btn @click="activateAlert = false" :color="config.primary">
              Ok
            </v-btn>
          </v-row>
        </v-container>
      </v-overlay>
      <router-view></router-view>
    </v-content>
    <Footer/>
    <div id="loadfonts"></div>
  </v-app>
</template>

<script>
import config from '@/config/config'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import UserService from '@/services/UserService'
import { mapGetters } from 'vuex'

export default {
  theme: {
    dark: true
  },
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  data () {
    return {
      config,
      alertColor: 'red',
      activateAlert: false,
      alertText: '',
      alertProgress: 0,
      error: null,
      alertType: '',
      navbarVisible: true
    }
  },
  methods: {
    async importFonts () { // Loads fonts from server and imports them into the site as @font-face
      try { // Also immediately loads the font by createing an element with the given font-family
        const response = await UserService.getFonts()
        const array = response.data.files
        const div = document.querySelector('#loadfonts');
        await array.forEach(file => {
          const fileArray = file.split('-')
          const newStyle = document.createElement('style');
          let type
          if (fileArray[2] == '.ttf') {
            type = 'truetype'
          } else if (fileArray[2] == '.otf') {
            type = 'opentype'
          } else if (fileArray[2] == '.woff') {
            type = 'woff'
          } else if (fileArray[2] == '.woff2') {
            type = 'woff2'
          }
          newStyle.appendChild(document.createTextNode("\
            @font-face {\
                font-family: " + fileArray[0] + ";\
                src: url('" + config.backendURL + '/public/fonts/' + file + "') format('" + type + "');\
                font-style: " + 'normal' + ";\
                font-weight: " + fileArray[1] + ";\
            }\
          "));
          document.head.appendChild(newStyle); // Add a div with the font-family that was just registered to prematurally load the font into the website
          const newDiv = document.createElement("div");
          newDiv.style.fontFamily = fileArray[0];
          div.appendChild(newDiv);
        })
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async closeError () {
      if (this.error != null) {
        document.getElementById("e").classList.remove('error-overlay')
        document.getElementById("e").classList.add('error-overlay-gone')
        setTimeout(() => {
          if (this.error != null) this.error = null
        }, 500);
      }
    },
    async closeAlert () {
      document.getElementById("a").classList.remove('main-overlay')
      document.getElementById("a").classList.add('main-overlay-gone')
      setTimeout(() => {
        this.activateAlert = false
      }, 500);
    },
    navigateTo (route) {
      this.$router.push(route)
    },
    async startUp () {
      // Check if the website is using https, if not, the location is switched.
      if (location.protocol !== 'https:' && config.secure) {
          location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }
      // Checks to see if the user jwt token is valid, if so the client will stay logged in.
      //If not, the client is logged off and an error is presented.
      if (this.loggedIn) {
        UserService.checkToken({token: this.getUser.token}).catch(error => {
          this.$store.dispatch('logout')
          this.$store.dispatch('setAlert', error.response.data)
        })
      } else {
        // If the user is not logged in, just set an alert message to the bottom that tells the user about cookies. Yum!
        this.alertText = `<h3>This site uses cookies. For more information, see the about section below.<br> By browsing this website, you are agreeing with our <a href="/#/legal">terms and conditions.</a></h3>`
        this.activateAlert = true
      }
    }
  },
  computed: {
    // Map the getters from vuex
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser',
      getAlert: 'getAlert'
    })
  },
  watch: {
    // Watch the alert getter. If this returns something other than null, the server will display the error using the above alert messaging system.
    getAlert: function () {
      if (typeof this.getAlert == 'string') {
          this.alertColor = 'red'
          this.error = {error: 'Custom error', message: this.getAlert}
      } else if (this.getAlert.error) {
        if (this.getAlert.response && this.getAlert.response.status == 401) { // Log the user out if error code is 401
          this.alertColor = 'red'
          this.$store.dispatch('logout')
          this.error = {error: 'Token authentication error', message: 'You have been logged out for security reasons. Please sign in again.'}
        } else {
          this.alertColor = 'red'
          this.error = this.getAlert.response.data
        }
      } else if (this.getAlert.notification) {
        this.alertColor = config.secondary
        this.error = {message: this.getAlert.notification}
        setTimeout(() => {
          this.closeError()
        }, 2000);
      }
    },
    '$route.path' (to) {
      if (to == '/create') {
        this.navbarVisible = true
      } else if (to == '/changepassowrd') {
        this.navbarVisible = false
      } else {
        this.navbarVisible = true
      }
    }
  },
  mounted () {
    // This gets executed when the website gets opened from the browser.
    // This will also get executed when the page is refreshed.
    this.importFonts()
    this.startUp()
    if (this.$route.name == 'create') {
      this.navbarVisible = true
    } else if (this.$route.name == 'changepassowrd') {
      this.navbarVisible = false
    } else {
      this.navbarVisible = true
    }
  }
};
</script>

<style>

.main-overlay {
  position: fixed;
  width: 70%;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 80px;
  z-index: 2;
  animation: alert 0.8s 1;
}

.main-overlay-gone {
  position: fixed;
  width: 70%;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 80px;
  z-index: 2;
  animation: alert-gone 0.8s 1;
}

.error-overlay {
  position: fixed;
  width: 70%;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  animation: error 0.8s 1;
}

.error-overlay-gone {
  position: fixed;
  width: 70%;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  animation: error-gone 0.8s 1;
}

.main-div {
  width: 100%;
  height: 100%;
  margin: none;
  padding: none;
  border: none;
}

#small-overlay {
  display: none;
}

@media only screen and (max-width: 1082px) {
  .main-overlay {
    position: fixed;
    width: 90%;
    height: 80px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 80px;
    z-index: 2;
    animation: alert 1s 1;
  }

}

@media only screen and (max-width: 844px) {
  .main-overlay {
    display: none;
  }

  #small-overlay {
    display: unset;
  }
}


@keyframes alert {
  from {bottom: -120px}
  to {bottom: 80px}
}

@keyframes error {
  from {top: -120px}
  to {top: 80px}
}

@keyframes alert-gone {
  from {bottom: -120px}
  to {bottom: 80px}
}

@keyframes error-gone {
  from {top: 80px}
  to {top: -120px}
}

</style>